import asyncActionType from "../../utils/asyncActionType";

export const CREATE_CREDIT_NOTE = asyncActionType("CREATE_CREDIT_NOTE");
export const FETCH_CREDIT_NOTE = asyncActionType("FETCH_CREDIT_NOTE");
export const FETCH_CREDIT_NOTES = asyncActionType("FETCH_CREDIT_NOTES");
